import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AuthSource =
  | "telegram"
  | "telegram_session"
  | "phone"
  | "yandex"
  | "unauthorized";

interface AuthState {
  userId: string | null;
  authSource: AuthSource;
  setAuth: (id: string | null, source: AuthSource) => void;
  initData: string | null;
  setInitData: (initData: string | null) => void;
  sessionToken: string | null;
  setSessionToken: (sessionToken: string | null) => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      userId: null,
      initData: null,
      sessionToken: null,
      authSource: "unauthorized",
      setAuth: (userId, authSource) => set({ userId, authSource }),
      setInitData: (initData) => set({ initData }),
      setSessionToken: (sessionToken) => set({ sessionToken }),
    }),
    {
      name: "auth-store",
    }
  )
);
